export function normalizeDateValue(
  value: string,
  yearFormat?: 'YY' | 'YYYY',
): string {
  if (!value || yearFormat === 'YY') return value;
  const mmYyMatch = /^(\d{2})\/(\d{2})$/.exec(value);
  if (mmYyMatch) {
    const [, month, yy] = mmYyMatch;
    return `${month}/20${yy}`;
  }
  return value;
}
